import React, { useMemo } from "react";
import { CountryStatsEntry } from "../../types/PublicListingStats";
import { CountryRevealLevel } from "../../types/PublicListing";

interface CountryDistributionProps {
  countries: CountryStatsEntry[];
  displayLevel: CountryRevealLevel;
}

const countryNames = new Intl.DisplayNames(["en"], { type: "region" });

function getCountryName(code: string): string {
  try {
    return countryNames.of(code) ?? code;
  } catch {
    return code;
  }
}

const CountryDistribution: React.FC<CountryDistributionProps> = ({
  countries,
  displayLevel,
}) => {
  const visibleCountries = useMemo(() => {
    const limit = displayLevel === "top3" ? 3 : 10;
    return countries.slice(0, limit);
  }, [countries, displayLevel]);

  if (visibleCountries.length === 0) return null;

  const maxCount = visibleCountries[0]?.customerCount ?? 1;

  return (
    <div className="country-distribution">
      <div className="section-title">Top Countries</div>
      <div className="country-bars">
        {visibleCountries.map((entry) => {
          const pct = Math.max((entry.customerCount / maxCount) * 100, 4);
          return (
            <div className="country-row" key={entry.country}>
              <div className="country-name">
                {getCountryName(entry.country)}
              </div>
              <div className="country-bar-track">
                <div
                  className="country-bar-fill"
                  style={{ width: `${pct}%` }}
                />
              </div>

            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CountryDistribution;
